import { createStore } from 'vuex';
import { cloneObject } from 'utils/index';
import * as user from '../modules/user';
import * as generic from '../modules/generic';
import * as productComparison from '../modules/product-comparison';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  // basic infos (id & avail. industries) about the product
  productBaseInfo: payload.productBaseInfo,
  // the actual pigment data, note that this will be empty as long as there is no industry selected
  pigment: payload.pigment ? cloneObject(payload.pigment) : null,
  fieldManifest: cloneObject(payload.fieldManifest),
  activeIndustry: payload.activeIndustry,
  industries: payload.industries,
  productGroups: payload.productGroups,
  excludeFromDataTable: payload.excludeFromDataTable,
  backlink: payload.backlink,
  documentFavorite: null,
  competitorApp: payload.competitorApp ? cloneObject(payload.competitorApp) : null,
  regionList: payload.regionList
};

const store = createStore({
  modules: {
    user,
    generic,
    productComparison
  },
  state,
  getters,
  actions,
  mutations
});

store.watch((rootState) => rootState.user.activeUser, () => {
  store.dispatch('loadPigment');
});

user.init(store);
generic.init(store);

export default store;
